// extracted by mini-css-extract-plugin
module.exports = {"faq":"faq_faq__bsIiQ","faq__titles":"faq_faq__titles__2kJrY","footer":"faq_footer__3kXR_"};